export default "__VITE_ASSET__a15699ba__"